import clsx from 'clsx';
import { memo } from 'react';

import { useTranslatedEntity, useWindowSize } from '../../hooks';
import type { NomineeType } from '../../types';
import { getNomineeTeam } from '../../utils/nomineeHelper';

import * as style from './style.module.scss';

const DetailedScore = ({ nominee }: { nominee: NomineeType }) => {
  const size = useWindowSize();
  const isMobile = size.width < 768;

  const team = getNomineeTeam(nominee);
  const match = nominee.matchDetails;
  const homeTeamName = useTranslatedEntity(match?.homeTeam).displayName ?? '';
  const awayTeamName = useTranslatedEntity(match?.awayTeam).displayName ?? '';
  const homeTeamScore = match?.score?.total?.home ?? '';
  const awayTeamScore = match?.score?.total?.away ?? '';

  const trimTeamName = (teamName: string) => {
    if (!isMobile) return teamName;
    if (homeTeamName.length + awayTeamName.length > 20) {
      return teamName.length < 10 ? teamName : teamName.substring(0, 10).concat('...');
    }
    return teamName;
  };

  return (
    <div className={style.cardMatch}>
      <div className={style.cardMatchTeam}>
        <span
          className={clsx(style.cardMatchTeamName, {
            [style.cardMatchWinner]: team.id === match?.homeTeam?.id,
          })}>
          {trimTeamName(homeTeamName)}
        </span>
        <span className={clsx(team.id === match?.homeTeam?.id && style.cardMatchWinner)}>{homeTeamScore}</span>
      </div>
      <div> - </div>
      <div className={style.cardMatchTeam}>
        <span className={clsx(team.id === match?.awayTeam?.id && style.cardMatchWinner)}>{awayTeamScore}</span>
        <span
          className={clsx(style.cardMatchTeamName, {
            [style.cardMatchWinner]: team.id === match?.awayTeam?.id,
          })}>
          {trimTeamName(awayTeamName)}
        </span>
      </div>
    </div>
  );
};

export default memo(DetailedScore);
